import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/games/word-guess/_components/word-guess-game.tsx");
